
import {Component, Vue} from "vue-property-decorator";
import i18n from "../plugins/vue-i18n";
import DocumentUser from "@/components/User/DocumentUser.vue";
import ParameterUser from "@/components/User/ParameterUser.vue";
import Baskets from "@/components/utils/Baskets.vue";
import BillingUser from "@/components/User/BillingUser.vue";


@Component({
    components: {
        ParameterUser,
        DocumentUser,
        Baskets,
        BillingUser
    },
})
export default class User extends Vue {
    tab = null;
    items = [
        //   { tab: i18n.tc("user.tab.parameter"), content: "ParameterUser" },
        {tab: i18n.tc("user.tab.files"), content: "DocumentUser"},
        {tab: i18n.tc("user.tab.history"), content: "Baskets", isDeleting: false},
        // { tab: i18n.tc("user.tab.billing"), content: "BillingUser" },
    ];

    mounted() {

        if (this.$route.query.page != undefined) {
            switch (this.$route.query.page) {
                case "0":
                    this.tab = 0;
                    break;
                case "1":
                    this.tab = 1;
                    break;
                case "2":
                    this.tab = 2;
                    break;
                case "3":
                    this.tab = 3;
                    break;
            }
        }
    }

}


